// extracted by mini-css-extract-plugin
export default {"langaugeForm":"ChangeUiLanguage_langaugeForm__P7op5"};